import { render, staticRenderFns } from "./LicenseDropdownItem.vue?vue&type=template&id=3e65077c"
import script from "./LicenseDropdownItem.vue?vue&type=script&lang=js"
export * from "./LicenseDropdownItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports